'use client';

import { createContext, useEffect } from 'react';

import { useHash, useHashScroll } from '@/utils/hashChange';

const ScrollContext = createContext();

const ScrollProvider = ({ children }) => {
  const [hash] = useHash();
  const { scrollToHash } = useHashScroll();

  useEffect(() => {
    if (hash) {
      scrollToHash(hash);
    }
  }, [hash, scrollToHash]);

  return <ScrollContext.Provider value={{}}>{children}</ScrollContext.Provider>;
};

export { ScrollProvider, ScrollContext };
